import { useState } from 'react';
import i18n from 'i18next';

import { ReactComponent as ZoomIcon } from '../../../assets/icons/zoom-input.svg';
import PortSearchModal from '../../screens/common/PortSearchModal/PortSearchModal';
import IconButton from '../Buttons/IconButton';
import SvgConverter from '../Common/SvgConverter';
import FormInput from '../Inputs/FormInput';

const PortNameSelector = ({
  placeholder = i18n.t('translation:default.fields.portName.select'),
  label = i18n.t('translation:default.fields.portName.label'),
  rules = [],
  name,
  editMode,
  portType,
  countryCode = '',
  cityCode = '',
  stateCode = '',
  zipCode = '',
  portCode = '',
  portName = '',
  onChange = () => {},
  margin = 'mb-0',
  handlePortDetails,
  labelForTestId,
}) => {
  const [modal, setModal] = useState(false);

  const handleSelect = (data) => {
    handlePortDetails(data);
    setModal(false);
  };

  return (
    <>
      <FormInput
        onChange={onChange}
        placeholder={placeholder}
        label={label}
        margin={margin}
        rules={rules}
        name={name}
        editMode={editMode}
        addonAfter={
          <IconButton onClick={() => setModal(true)}>
            <SvgConverter Icon={ZoomIcon} color="muted" />
          </IconButton>
        }
      />
      <PortSearchModal
        open={modal}
        handleSelect={handleSelect}
        handleClose={() => setModal(false)}
        portType={portType}
        countryCode={countryCode}
        cityCode={cityCode}
        stateCode={stateCode}
        zipCode={zipCode}
        portCode={portCode}
        portName={portName}
        labelForTestId={`${labelForTestId}-modal`}
      />
    </>
  );
};

export default PortNameSelector;
